// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import { getAnalyticsMetadataAttribute } from '@cloudscape-design/component-toolkit/internal/analytics-metadata';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalTiles from './internal';
import analyticsSelectors from './analytics-metadata/styles.css.js';
const Tiles = React.forwardRef((props, ref) => {
    const baseComponentProps = useBaseComponent('Tiles', {
        props: { columns: props.columns, readOnly: props.readOnly },
    });
    const componentAnalyticsMetadata = {
        name: 'awsui.Tiles',
        label: { root: 'self' },
        properties: {
            value: `${props.value}`,
            valueLabel: `.${analyticsSelectors.selected}`,
        },
    };
    return (React.createElement(InternalTiles, { ref: ref, ...props, ...baseComponentProps, ...getAnalyticsMetadataAttribute({
            component: componentAnalyticsMetadata,
        }) }));
});
applyDisplayName(Tiles, 'Tiles');
export default Tiles;
//# sourceMappingURL=index.js.map